<template>
  <div class="customer-po-open__list-rfq-3">
    <list-form
      ref="list-form"
      :config="config"
      :formModel="formModel"
      :prepareClone="prepareClone"
      @onChangeDataOrigin="handleChangeDataOrigin"
    >
      <template v-slot:title="{ title }">
        <h3 class="blue-text">{{title}}</h3>
      </template>
      <template v-slot="{ data, autoSave, handleCommand, ha }">
        <edit-form
          :disabled="disabled"
          :data="data"
          :model="formModel"
          :isNew="false"
          :withClone="withClone"
          :withDownload="withDownload"
          :config="{ id: config.id }"
          @onAutoSave="autoSave"
          @command="handleCommand"
          @download="onDownloadPDF"
        />
      </template>
    </list-form>
    <button-line
      v-if="showButton && !disabled"
      :disabled="disabledNext"
      @click="handlerClick"
    >
      {{L10n('create-po')}}
    </button-line>
  </div>
</template>

<script>
import listFormConfig from './ListFormConfig.json'
import { waitValue } from '@/utils/promises.js'
import { MainModel } from '@/models/RFQ3.js'
import { ServicePdf } from '@/services/pdf-generators'
import { toDate } from '@/utils/filters'
import { downloadBase64 } from '@/utils/files'

export default {
  name: 'ListFormCustomerPoOpen',
  components: {
    'button-line': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ButtonLine.vue'),
    'list-form': () => import(/* webpackChunkName: 'ListForm' */ '@/components/ListForm/Index'),
    'edit-form': () => import(/* webpackChunkName: 'Shared' */ './FormRFQ3.vue')
  },
  props: {
    disabled: { type: Boolean, default: false },
    moduleName: { type: String, required: true },
    data: { type: Object, required: true },
    isValid: { type: Boolean, required: true },
    eventID: { type: String, required: true },
    showButton: { type: Boolean, default: false },
    withClone: { type: Boolean, default: false },
    withDownload: { type: Boolean, default: false }
  },
  created () {
    this.$bus.$on(`refresh-data-${this.eventID}`, this.loadData)
  },
  beforeDestroy () {
    this.$bus.$off(`refresh-data-${this.eventID}`, this.loadData)
  },
  watch: {
    'data.rfqid': {
      immediate: true,
      handler (value) {
        this.loadData()
      }
    }
  },
  data () {
    listFormConfig.id = `${this.moduleName}-list-rfq3`
    return {
      disabledNext: true,
      config: listFormConfig
    }
  },
  methods: {
    prepareClone (data) {
      return {
        ...data,
        chosen: false
      }
    },
    checkRequiredFields (dataList) {
      let requiredFields = [
        'partID', 'qty', 'partSN', 'price', 'currencyID', 'conditionID'
      ]
      return !dataList.length ||
        dataList.some((quote) => {
          return requiredFields.some((field) => !quote[field])
        })
    },
    handlerClick () {
      if (this.disabledNext) return
      this.$emit('command', 'show-po')
    },
    getListForm () {
      return waitValue(() => this.$refs['list-form'])
    },
    handleChangeDataOrigin (data) {
      let value = Array.from(data)
      this.$store.commit(`${this.moduleName}/SET`, { key: 'listRFQ3', value })
      this.validate()
      this.$nextTick(() => {
        this.$emit('command', 'came-list-rfq-3')
      })
    },
    validate () {
      this.getListForm()
        .then((listForm) => {
          let dataList = listForm.getData()
          this.disabledNext = this.checkRequiredFields(dataList)
          this.$emit('update:isValid', !this.disabledNext)
        })
    },
    formModel () {
      return this.copyObjectProps(new MainModel(), {
        rfqid: this.data.rfqid
      })
    },
    loadData () {
      this.getListForm()
        .then((listForm) => {
          if (!this.data.rfqid) return
          let filters = `rfqid == "${this.data.rfqid}"`
          listForm.setFilters(filters)
          listForm.loadData()
        })
    },
    async onDownloadPDF ({ id, logoKey }) {
      const list = await this.getListForm()

      try {
        list.isLoading = true
        const { data: pdfBase64 } = await ServicePdf.generatePackingSlip({ id, logoKey, translate: this.L10n })
        await downloadBase64(pdfBase64, `ATA106_${toDate(new Date(), 'YYYY-MM-DD')}`)
      } catch (e) {

      } finally {
        list.isLoading = false
      }
    }
  }
}
</script>
<style lang="stylus">
  .customer-po-open__list-rfq-3{
    .list-form__header{
      padding-left 0
      padding-right 0
    }
  }
</style>
